import { useState } from "react";
import { Header } from "@/components/sections/Header";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { Manifesto } from "@/components/sections/Manifesto";
import { TrackRecord } from "@/components/sections/TrackRecord";
import { VideoShowcase } from "@/components/sections/VideoShowcase";
import { WhaleFeed } from "@/components/sections/WhaleFeed";
import { Pricing } from "@/components/sections/Pricing";
import { Faq } from "@/components/sections/Faq";
import { Footer } from "@/components/sections/Footer";
import { PaymentModal } from "@/components/sections/PaymentModal";

const FRANK_IMAGE =
  "https://customer-assets-agu9un31.emergentagent.net/job_pensive-mahavira-9/artifacts/rtm91ra8_IMG_7580.webp";
const INSIDER_VIDEO =
  "https://customer-assets-agu9un31.emergentagent.net/job_pensive-mahavira-9/artifacts/40cr6e1c_snaptik_7681556463805861141_v3.mov";

export default function Home() {
  const [payOpen, setPayOpen] = useState(false);
  const openPay = () => setPayOpen(true);

  return (
    <div className="relative">
      <Header onJoin={openPay} />
      <main>
        <Hero onJoin={openPay} />
        <Marquee />
        <VideoShowcase src={INSIDER_VIDEO} />
        <Manifesto />
        <TrackRecord />
        <WhaleFeed frankImage={FRANK_IMAGE} />
        <Pricing onJoin={openPay} />
        <Faq />
      </main>
      <Footer onJoin={openPay} />
      <PaymentModal open={payOpen} onOpenChange={setPayOpen} />
    </div>
  );
}
